import dayjs from "dayjs";
import { TimesheetRequestBtnPermission } from "../enums";
import { PayperiodFilterType } from "../types";

/**
 * Timecard Request Utilities
 * 
 * @description This class contains utility functions for timecard requests.
 * @author Vishwesh Shukla 
 */
export class TimecardRequestUtil { 

    static isAllowed({
        allowed, 
        configs, 
        payperiods,
        dateToCheck
    }: {
        allowed?: boolean, 
        configs?: TimesheetRequestBtnPermission[], 
        payperiods: PayperiodFilterType[],
        dateToCheck?: Date | string
    }): boolean { 
        // 1. First check for allowed flag - if not present or false, return false
        if (!allowed) {
            return false;
        }

        // 2. If allowed is true, proceed to check configs
        // If no configs provided, default to allowed
        if (!configs || configs.length === 0) {
            // return true;
            return true;
        }

        // 3. If no payperiods provided, cannot validate against pay period configs
        if (!payperiods || payperiods.length === 0) {
            return false;
        }

        // Use today if no date provided
        const checkDate = dateToCheck ? dayjs(dateToCheck) : dayjs();
        
        // First payperiod is the current pay period
        const currentPayperiod = payperiods[0];
        const payperiodStart = dayjs(currentPayperiod.start_datetime);
        const payperiodEnd = dayjs(currentPayperiod.end_datetime);

        // Check if date is in current pay period
        const isInCurrentPayperiod = checkDate.isSameOrAfter(payperiodStart, 'day') && 
                                      checkDate.isSameOrBefore(payperiodEnd, 'day');
        
        // Check if date is in past pay period (before current pay period)
        const isInPastPayperiod = checkDate.isBefore(payperiodStart, 'day');

        // 4. Check configs
        const hasCurrentPayperiodConfig = configs.includes(TimesheetRequestBtnPermission.CURRENT_PAYPERIOD);
        const hasPastPayperiodConfig = configs.includes(TimesheetRequestBtnPermission.PAST_PAYPERIOD);

        // If both configs are present, allow if date is in either current or past
        if (hasCurrentPayperiodConfig && hasPastPayperiodConfig) {
            return isInCurrentPayperiod || isInPastPayperiod;
        }

        // If only CURRENT_PAYPERIOD config, check if in current pay period
        if (hasCurrentPayperiodConfig) {
            return isInCurrentPayperiod;
        }

        // If only PAST_PAYPERIOD config, check if in past pay period
        if (hasPastPayperiodConfig) {
            return isInPastPayperiod;
        }

        // Default to not allowed if no matching config
        return false;
    }

}